import { createSlice } from "@reduxjs/toolkit";

export const juryAboutDataSlice = createSlice({
    name: 'juryAboutData',
    initialState: {
        name:"",
        designation:"",
        about:"",
        linkedin:"",
        twitter:"",
        facebook:"",
        index: 0
    },
    reducers:{
        setData(state, action) {
            state.name = action.payload.NAME
            state.designation = action.payload.DESIGNATION
            state.about = action.payload.JURY_BIO
            state.linkedin =action.payload.LINKEDIN_LINK
            state.twitter = action.payload.TWITTER_LINK
            state.facebook = action.payload.FB_LINK
        },
        setIndex(state, action) {
            state.index = action.payload
        }
    }
})


export const juryAboutDataActions = juryAboutDataSlice.actions